import { render, staticRenderFns } from "./ProviderViewOriginsTab.vue?vue&type=template&id=8bbb3bbe"
import script from "./ProviderViewOriginsTab.vue?vue&type=script&lang=js"
export * from "./ProviderViewOriginsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports